import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminCreateBuyerListInput,
  AdminCreateBuyerListMutation,
  AdminCreateBuyerListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminCreateBuyerListMutation = graphql(`
  mutation adminCreateBuyerList($input: AdminCreateBuyerListInput!) {
    adminCreateBuyerList(input: $input) {
      id
      name
      ownerId
      companyId
      sharingType
      createdAt
      updatedAt
      isDeleted
    }
  }
`);

export function useAdminCreateBuyerList(
  options?: UseMutationOptions<
    AdminCreateBuyerListMutation,
    unknown,
    AdminCreateBuyerListMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminCreateBuyerListMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
  });
  return {
    ...rest,
    mutate: (input: AdminCreateBuyerListInput) => innerMutate({ input }),
  };
}
